module.exports = __webpack_public_path__ + "img/shjf.7f58cbee.svg";